export const COVER_IMAGE_PLACEHOLDER_ID = 'profile_picture_placeholder_o56tme';
export const LOGO_IMAGE_PLACEHOLDER_ID = 'NonprofitAvatarPlaceholder';
